// extracted by mini-css-extract-plugin
export var mainContent = "j_J";
export var mainContentWithGlobal = "j_K";
export var rootPath = "j_H";
export var skeletonMenuContainer = "j_L";
export var skeletonRow = "j_M";